import { render, staticRenderFns } from "./CategoryCarousel.vue?vue&type=template&id=5c7cb09e&scoped=true"
import script from "./CategoryCarousel.vue?vue&type=script&lang=js"
export * from "./CategoryCarousel.vue?vue&type=script&lang=js"
import style0 from "./CategoryCarousel.vue?vue&type=style&index=0&id=5c7cb09e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7cb09e",
  null
  
)

export default component.exports